import { reportErrorToNewRelic } from "../helpers/newRelic";
import { setStoredUserData, setToken } from "../helpers/session";
import httpService from "./HttpService";

class AuthService {
  constructor() {
    this.loginBooking = this.loginBooking.bind(this);
    this.exchangeAccessToken = this.exchangeAccessToken.bind(this);
  }

  // Guarda el token y los datos de la reserva de una sesión recién creada.
  storeSession(token, userData) {
    setToken(token);
    setStoredUserData(userData);
  }

  loginBooking(data) {
    const { reserva, apellido, companyid, captcha_token, captcha_fallback } =
      data;
    if (!reserva || !apellido || !companyid) {
      return Promise.reject("Datos faltantes o incorrectos");
    }
    const body = { reserva, apellido, companyid };
    // `captcha_fallback`: motivo por el que se sale sin token (nunca con uno).
    if (captcha_token) body.captcha_token = captcha_token;
    else if (captcha_fallback) body.captcha_fallback = captcha_fallback;
    return httpService
      .post(process.env.REACT_APP_LOGIN_EP, body, { skipErrorToast: true })
      .then(res => {
        if (res.data.token) {
          this.storeSession(res.data.token, {
            CID: data.reserva,
            LastName: data.apellido,
            CompanyID: data.companyid
          });
        }
        return res.data;
      })
      .catch(err => {
        reportErrorToNewRelic("LOGIN_EP", err);
        return Promise.reject(err);
      });
  }

  // Canje del token de acceso del magic link (?t=). Devuelve { token, ... };
  // la sesión (token + UserData) la guarda quien llama, que conoce el CID.
  exchangeAccessToken(token) {
    return httpService
      .post(
        process.env.REACT_APP_ACCESS_TOKEN_EXCHANGE_EP,
        { token },
        { skipErrorToast: true }
      )
      .then(res => res.data)
      .catch(err => {
        reportErrorToNewRelic("ACCESS_TOKEN_EXCHANGE_EP", err);
        return Promise.reject(err);
      });
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
